exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-info-card[data-v-6afb6b1c]{border:1px solid #000;text-align:left;padding:10px;background-color:#fff;margin:10px 0}@media screen and (max-width:768px){.price-info-card[data-v-6afb6b1c]{margin:10px}}.price-info-card__book-name[data-v-6afb6b1c]{font-weight:700;font-size:16px;color:#ff5b60}.price-info-card .not-unlimited[data-v-6afb6b1c]{color:#ff5b60}.price-info-card .is-unlimited[data-v-6afb6b1c]{color:green}.title[data-v-6afb6b1c]{font-weight:700}.unlimited-tag[data-v-6afb6b1c]{margin:0 0 5px}.unlimited-img[data-v-6afb6b1c]{height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6afb6b1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/priceList/parts/PriceInfoCard.vue
// module id = 491
// module chunks = 0